import { lazy } from 'react';
import Loadable from 'components/Loadable';
import EditGraph from 'pages/comptroller/graph-defination/edit-graph';
import GraphDefination from 'pages/comptroller/graph-defination/index';
import SLACreate from 'pages/comptroller/service-level-agreement/Create';
import ServiceLevel from 'pages/comptroller/service-level-agreement/index';
import CreateGraph from 'pages/comptroller/graph-defination/create-graph';
import DetailsGraph from 'pages/comptroller/graph-defination/details-graph';
import KeyManagementArea from 'pages/comptroller/key-management-area/index';
import COEKeyManagementArea from 'pages/comptroller/key-management-area/COE-KeyManagementArea';
import DetailsKeyManagementArea from 'pages/comptroller/key-management-area/Details-KeyManagementArea';
import WorkFlowCreate from 'pages/comptroller/workflow/WorkflowCreate';
import WorkFlowList from 'pages/comptroller/workflow/index';
import WorkFlowView from 'pages/comptroller/workflow/WorkflowView';
import WorkflowEdit from 'pages/comptroller/workflow/WorkflowEdit';
import ReportListPage from 'pages/comptroller/report/index';

const COEEntity = Loadable(lazy(() => import('pages/comptroller/entity/COE-Entity')));
const DetailsEntity = Loadable(lazy(() => import('pages/comptroller/entity/Details-Entity')));

const COEModule = Loadable(lazy(() => import('pages/comptroller/module/COE-Module')));
const DetailsModule = Loadable(lazy(() => import('pages/comptroller/module/Details-Module')));

const COEVertical = Loadable(lazy(() => import('pages/comptroller/vertical/COE-Vertical')));
const DetailsVertical = Loadable(lazy(() => import('pages/comptroller/vertical/Details-Vertical')));

const COEHorizon = Loadable(lazy(() => import('pages/comptroller/horizon/COE-Horizon')));
const DetailsHorizon = Loadable(lazy(() => import('pages/comptroller/horizon/Details-Horizon')));

const COETask = Loadable(lazy(() => import('pages/comptroller/task/COE-Task')));
const DetailsTask = Loadable(lazy(() => import('pages/comptroller/task/Details-Task')));

const COETaskGroup = Loadable(lazy(() => import('pages/comptroller/task-group/COE-TaskGroup')));
const DetailsTaskGroup = Loadable(lazy(() => import('pages/comptroller/task-group/Details-TaskGroup')));

const COESolutions = Loadable(lazy(() => import('pages/comptroller/solutions/COE-Solutions')));
const DetailsSolutions = Loadable(lazy(() => import('pages/comptroller/solutions/Details-Solutions')));

const COESolutionTask = Loadable(lazy(() => import('pages/comptroller/solutionTask/COE-SolutionTask')));
const DetailsSolutionTask = Loadable(lazy(() => import('pages/comptroller/solutionTask/Details-SolutionTask')));

const COEManagementHierarchy = Loadable(lazy(() => import('pages/comptroller/management-hierarchy/COE-ManagementHierarchy')));
const DetailsManagementHierarchy = Loadable(lazy(() => import('pages/comptroller/management-hierarchy/Details-ManagementHierarchy')));

const COEFunctionMaster = Loadable(lazy(() => import('pages/comptroller/function-master/COE-FunctionMaster')));
const DetailsFunctionMaster = Loadable(lazy(() => import('pages/comptroller/function-master/Details-FunctionMaster')));

const COEHRPositionMaster = Loadable(lazy(() => import('pages/comptroller/hrposition-master/COE-HRPositionMaster')));
const DetailsHRPositionMaster = Loadable(lazy(() => import('pages/comptroller/hrposition-master/Details-HRPoistionMaster')));

const COEHRMaster = Loadable(lazy(() => import('pages/comptroller/hrmaster/COE-HRMaster')));
const DetailsHRMaster = Loadable(lazy(() => import('pages/comptroller/hrmaster/Deatails-HRMaster')));

const DetailsInvitation = Loadable(lazy(() => import('pages/comptroller/invitations/Details-Invitations')));

const COEProcessRoleMaster = Loadable(lazy(() => import('pages/comptroller/processrole-master/COE-ProcessRoleMaster')));
const DetailsProcessRoleMaster = Loadable(lazy(() => import('pages/comptroller/processrole-master/Details-ProcessRoleMaster')));

const COEConditionMaster = Loadable(lazy(() => import('pages/comptroller/condition-master/COE-ConditionMaster')));
const DetailsConditionMaster = Loadable(lazy(() => import('pages/comptroller/condition-master/Details-ConditionMaster')));

const DetailsProcessAdmoinistration = Loadable(lazy(() => import('pages/comptroller/process-administration/Details-ProcessAdministration')));
const COEProcessAdmoinistration = Loadable(lazy(() => import('pages/comptroller/process-administration/COE-ProcessAdministration')));

const COEAccessControl = Loadable(lazy(() => import('pages/comptroller/access-control/COE-AccessControl')));
const DetailsAccessControl = Loadable(lazy(() => import('pages/comptroller/access-control/Details-AccessControl')));

const UserPreferences = Loadable(lazy(() => import('pages/comptroller/user-preferences/index')));
const COEUserPreferences = Loadable(lazy(() => import('pages/comptroller/user-preferences/COE-UserPreferences')));
const DetailsUserPreferences = Loadable(lazy(() => import('pages/comptroller/user-preferences/Details-UserPreferences')));

const OffDay = Loadable(lazy(() => import('pages/comptroller/off-day/index')));
const COEOffDay = Loadable(lazy(() => import('pages/comptroller/off-day/COE-Offday')));
const DetailsOffDay = Loadable(lazy(() => import('pages/comptroller/off-day/Details-Offday')));

const Committee = Loadable(lazy(() => import('pages/comptroller/committee/index')));
const COECommittee = Loadable(lazy(() => import('pages/comptroller/committee/COECommittee')));
const DeatailsCommittee = Loadable(lazy(() => import('pages/comptroller/committee/DetailsCommitte')));

const Entity = Loadable(lazy(() => import('pages/comptroller/entity/index')));
const Horizon = Loadable(lazy(() => import('pages/comptroller/horizon/index')));
const Comptroller = Loadable(lazy(() => import('pages/comptroller/Comptroller')));
const Vertical = Loadable(lazy(() => import('pages/comptroller/vertical/index')));
const Solutions = Loadable(lazy(() => import('pages/comptroller/solutions/index')));

const Form = Loadable(lazy(() => import('pages/comptroller/form/index')));
const Task = Loadable(lazy(() => import('pages/comptroller/task/index')));
const Module = Loadable(lazy(() => import('pages/comptroller/module/index')));
const HRMaster = Loadable(lazy(() => import('pages/comptroller/hrmaster/index')));
const TaskGroup = Loadable(lazy(() => import('pages/comptroller/task-group/index')));
const Invitations = Loadable(lazy(() => import('pages/comptroller/invitations/index')));
const SolutionTask = Loadable(lazy(() => import('pages/comptroller/solutionTask/index')));
const AccessControl = Loadable(lazy(() => import('pages/comptroller/access-control/index')));
const FunctionMaster = Loadable(lazy(() => import('pages/comptroller/function-master/index')));
const ConditionMaster = Loadable(lazy(() => import('pages/comptroller/condition-master/index')));
const HRPositionMaster = Loadable(lazy(() => import('pages/comptroller/hrposition-master/index')));
const ProcessRoleMaster = Loadable(lazy(() => import('pages/comptroller/processrole-master/index')));
const ManagementHierarchy = Loadable(lazy(() => import('pages/comptroller/management-hierarchy/index')));
const ProcessAdministration = Loadable(lazy(() => import('pages/comptroller/process-administration/index')));
const StaticSolutionPath = Loadable(lazy(() => import('pages/comptroller/static-solution-path/index')));

const ComptrollerRoutes = [
	{
		path: 'comptroller',
		children: [
			{ index: true, element: <Comptroller /> },
			{
				path: 'key-management-area',
				children: [
					{ index: true, element: <KeyManagementArea /> },
					{ path: ':id', element: <KeyManagementArea /> },
					{ path: 'coe-kma', element: <COEKeyManagementArea /> },
					{ path: 'details', element: <DetailsKeyManagementArea /> },
				],
			},
			{
				path: 'form',
				children: [
					{ index: true, element: <Form /> },
					{ path: ':id', element: <Entity /> },
					{ path: 'coe-entity', element: <COEEntity /> },
					{ path: 'view', element: <DetailsEntity /> },
				],
			},
			{
				path: 'entities',
				children: [
					{ index: true, element: <Entity /> },
					{ path: ':id', element: <Entity /> },
					{ path: 'create', element: <COEEntity /> },
					{ path: 'edit', element: <COEEntity /> },
					{ path: 'view', element: <DetailsEntity /> },
				],
			},
			{
				path: 'module',
				children: [
					{ index: true, element: <Module /> },
					{ path: ':id', element: <Module /> },
					{ path: 'create', element: <COEModule /> },
					{ path: 'edit', element: <COEModule /> },
					{ path: 'view', element: <DetailsModule /> },
				],
			},
			{
				path: 'vertical',
				children: [
					{ index: true, element: <Vertical /> },
					{ path: ':id', element: <Vertical /> },
					{ path: 'create', element: <COEVertical /> },
					{ path: 'edit', element: <COEVertical /> },
					{ path: 'view', element: <DetailsVertical /> },
				],
			},
			{
				path: 'horizon',
				children: [
					{ index: true, element: <Horizon /> },
					{ path: ':id', element: <Horizon /> },
					{ path: 'details', element: <DetailsHorizon /> },
					{ path: 'coe-horizon', element: <COEHorizon /> },
				],
			},
			{
				path: 'task-group',
				children: [
					{ index: true, element: <TaskGroup /> },
					{ path: ':id', element: <TaskGroup /> },
					{ path: 'create', element: <COETaskGroup /> },
					{ path: 'edit', element: <COETaskGroup /> },
					{ path: 'view', element: <DetailsTaskGroup /> },
				],
			},
			{
				path: 'task',
				children: [
					{ index: true, element: <Task /> },
					{ path: ':id', element: <Task /> },
					{ path: 'create', element: <COETask /> },
					{ path: 'edit', element: <COETask /> },
					{ path: 'view', element: <DetailsTask /> },
				],
			},
			{
				path: 'solution',
				children: [
					{ index: true, element: <Solutions /> },
					{ path: ':id', element: <Solutions /> },
					{ path: 'view', element: <DetailsSolutions /> },
					{ path: 'create', element: <COESolutions /> },
					{ path: 'edit', element: <COESolutions /> },
				],
			},
			{
				path: 'solution-task',
				children: [
					{ index: true, element: <SolutionTask /> },
					{ path: ':id', element: <SolutionTask /> },
					{ path: 'create', element: <COESolutionTask page="create" /> },
					{ path: 'edit', element: <COESolutionTask page="edit" /> },
					{ path: 'view', element: <DetailsSolutionTask /> },
				],
			},
			{
				path: 'static-solution-path',
				children: [{ index: true, element: <StaticSolutionPath /> }],
			},
			{
				path: 'management-hierarchy',
				children: [
					{ index: true, element: <ManagementHierarchy /> },
					{ path: ':id', element: <ManagementHierarchy /> },
					{ path: 'coe-management-hierarchy', element: <COEManagementHierarchy /> },
					{ path: 'details', element: <DetailsManagementHierarchy /> },
				],
			},
			{
				path: 'function-master',
				children: [
					{ index: true, element: <FunctionMaster /> },
					{ path: ':id', element: <FunctionMaster /> },
					{ path: 'coe-function-master', element: <COEFunctionMaster /> },
					{ path: 'details', element: <DetailsFunctionMaster /> },
				],
			},
			{
				path: 'hr-position-master',
				children: [
					{ index: true, element: <HRPositionMaster /> },
					{ path: ':id', element: <HRPositionMaster /> },
					{ path: 'coe-hr-position-master', element: <COEHRPositionMaster /> },
					{ path: 'details', element: <DetailsHRPositionMaster /> },
				],
			},
			{
				path: 'hr-master',
				children: [
					{ index: true, element: <HRMaster /> },
					{ path: ':id', element: <HRMaster /> },
					{ path: 'coe-hr-master', element: <COEHRMaster /> },
					{ path: 'details', element: <DetailsHRMaster /> },
				],
			},
			{
				path: 'invitations',
				children: [
					{ index: true, element: <Invitations /> },
					{ path: ':id', element: <Invitations /> },
					{ path: 'view', element: <DetailsInvitation /> },
				],
			},
			{
				path: 'process-role-master',
				children: [
					{ index: true, element: <ProcessRoleMaster /> },
					{ path: ':id', element: <ProcessRoleMaster /> },
					{ path: 'coe-process-role-master', element: <COEProcessRoleMaster /> },
					{ path: 'details', element: <DetailsProcessRoleMaster /> },
				],
			},
			{
				path: 'condition-master',
				children: [
					{ index: true, element: <ConditionMaster /> },
					{ path: ':id', element: <ConditionMaster /> },
					{ path: 'create', element: <COEConditionMaster /> },
					{ path: 'edit', element: <COEConditionMaster /> },
					{ path: 'view', element: <DetailsConditionMaster /> },
				],
			},
			{
				path: 'access-control',
				children: [
					{ index: true, element: <AccessControl /> },
					{ path: ':id', element: <AccessControl /> },
					{ path: 'coe-access-control', element: <COEAccessControl /> },
					{ path: 'details', element: <DetailsAccessControl /> },
				],
			},
			{
				path: 'process-administration',
				children: [
					{ index: true, element: <ProcessAdministration /> },
					{ path: ':id', element: <ProcessAdministration /> },
					{ path: 'create', element: <COEProcessAdmoinistration /> },
					{ path: 'edit', element: <COEProcessAdmoinistration /> },
					{ path: 'view', element: <DetailsProcessAdmoinistration /> },
				],
			},
			{
				path: 'committee',
				children: [
					{ index: true, element: <Committee /> },
					{ path: ':id', element: <Committee /> },
					{ path: 'coe-committee', element: <COECommittee /> },
					{ path: 'details', element: <DeatailsCommittee /> },
				],
			},
			{
				path: 'user-preferences',
				children: [
					{ index: true, element: <UserPreferences /> },
					{ path: ':id', element: <UserPreferences /> },
					{ path: 'create', element: <COEUserPreferences /> },
					{ path: 'edit', element: <COEUserPreferences /> },
					{ path: 'view', element: <DetailsUserPreferences /> },
				],
			},
			{
				path: 'offday',
				children: [
					{ index: true, element: <OffDay /> },
					{ path: ':id', element: <OffDay /> },
					{ path: 'create', element: <COEOffDay /> },
					{ path: 'edit', element: <COEOffDay /> },
					{ path: 'view', element: <DetailsOffDay /> },
				],
			},
			{
				path: 'graph-defination',
				children: [
					{ index: true, element: <GraphDefination /> },
					{ path: ':id', element: <OffDay /> },
					{ path: 'create', element: <CreateGraph /> },
					{ path: 'edit', element: <EditGraph /> },
					{ path: 'view', element: <DetailsGraph /> },
				],
			},
			{
				path: 'service-level-agreement',
				children: [
					{ index: true, element: <ServiceLevel /> },
					{ path: 'create', element: <SLACreate /> },
				],
			},
			{
				path: 'work-flow',
				children: [
					{ index: true, element: <WorkFlowList /> },
					{ path: 'create', element: <WorkFlowCreate /> },
					{ path: 'view', children: [{ path: ':id', element: <WorkFlowView /> }] },
					{ path: 'edit', children: [{ path: ':id', element: <WorkflowEdit /> }] },
				],
			},
			{
				path: 'report',
				children: [{ index: true, element: <ReportListPage /> }],
			},
		],
	},
];

export default ComptrollerRoutes;
